import { HeyLightOrderStatus } from "../../HeyLight/heyLightOrderDTO.ts";

export function OrderStatusRenderer({
  status,
}: {
  status: HeyLightOrderStatus;
}) {
  switch (status) {
    case HeyLightOrderStatus.Pending:
      return (
        <span className={"bg-yellow-500 px-3 py-1 text-white rounded-md"}>
          In attesa
        </span>
      );
    case HeyLightOrderStatus.Cancelled:
      return (
        <span className={"bg-red-500 px-3 py-1 text-white rounded-md"}>
          Annullato
        </span>
      );
    case HeyLightOrderStatus.Refunded:
      return (
        <span className={"bg-blue-500 px-3 py-1 text-white rounded-md"}>
          Rimborsato
        </span>
      );
    case HeyLightOrderStatus.PartiallyRefunded:
      return (
        <span className={"bg-blue-500 px-3 py-1 text-white rounded-md"}>
          Parzialmente rimborsato
        </span>
      );
    case HeyLightOrderStatus.AwaitingConfirmation:
      return (
        <span className={"bg-blue-500 px-3 py-1 text-white rounded-md"}>
          In finalizzazione
        </span>
      );
    case HeyLightOrderStatus.Success:
      return (
        <span className={"bg-green-500 px-3 py-1 text-white rounded-md"}>
          Completato
        </span>
      );
    default:
      return (
        <span className={"bg-gray-500 px-3 py-1 text-white rounded-md"}>
          Stato sconosciuto: {status}
        </span>
      );
  }
}
